import {
  ADD_USEFUL_LINK_GROUP,
  GET_USEFUL_LINK_GROUPS,
  GET_USEFUL_LINK_GROUP_BY_ID,
  EDIT_USEFUL_LINK_GROUP_BY_ID,
  REMOVE_USEFUL_LINK_GROUP_BY_ID,
} from "../actions/useful-link-groups-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const usefulLinkGroupsReducer = (
  state = initialState,
  action: any
): ApiRequestState => {
  switch (action.type) {
    case (ADD_USEFUL_LINK_GROUP.REQUEST,
    GET_USEFUL_LINK_GROUP_BY_ID.REQUEST,
    GET_USEFUL_LINK_GROUP_BY_ID.REQUEST,
    EDIT_USEFUL_LINK_GROUP_BY_ID.REQUEST,
    REMOVE_USEFUL_LINK_GROUP_BY_ID.REQUEST):
      return {
        ...state,
        loading: true,
        error: null,
      };
    case (ADD_USEFUL_LINK_GROUP.SUCCESS,
    GET_USEFUL_LINK_GROUPS.SUCCESS,
    GET_USEFUL_LINK_GROUP_BY_ID.SUCCESS,
    EDIT_USEFUL_LINK_GROUP_BY_ID.SUCCESS,
    REMOVE_USEFUL_LINK_GROUP_BY_ID.SUCCESS):
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case (ADD_USEFUL_LINK_GROUP.FAILURE,
    GET_USEFUL_LINK_GROUPS.FAILURE,
    GET_USEFUL_LINK_GROUP_BY_ID.FAILURE,
    EDIT_USEFUL_LINK_GROUP_BY_ID.FAILURE,
    REMOVE_USEFUL_LINK_GROUP_BY_ID.FAILURE):
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { usefulLinkGroupsReducer };
